import { LOCALE_MESSAGES, setLocale } from "@/shared/i18n";

// Stesse lingue e stessi JSON dell'i18n condiviso: le viste legacy traducono da qui finche' esistono.
const messages = LOCALE_MESSAGES;
const listeners = new Set();
const STORAGE_KEY = "locale";

// La lingua dell'utente arriva dal profilo solo dopo il login: la persistiamo cosi'
// le pagine fuori dal flusso autenticato (404, login, signup) la rispettano al reload.
function storedLocale() {
  try {
    const locale = localStorage.getItem(STORAGE_KEY);
    return messages[locale] ? locale : null;
  } catch {
    return null;
  }
}

let currentLocale = storedLocale() || "en";
const fallbackLocale = "en";

function lookup(locale, key) {
  return key.split(".").reduce((value, part) => value?.[part], messages[locale]);
}

export function translate(key, values = {}) {
  const value = lookup(currentLocale, key) ?? lookup(fallbackLocale, key) ?? key;
  if (typeof value !== "string") return value;
  return Object.entries(values).reduce(
    (result, [name, replacement]) => result.replaceAll(`{${name}}`, String(replacement)),
    value,
  );
}

const i18n = {
  get locale() { return currentLocale; },
  set locale(locale) {
    if (!messages[locale] || locale === currentLocale) return;
    currentLocale = locale;
    setLocale(locale);
    document.documentElement.lang = locale;
    try { localStorage.setItem(STORAGE_KEY, locale); } catch { /* storage non disponibile */ }
    listeners.forEach((listener) => listener());
  },
  fallbackLocale,
  messages,
  subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export default i18n;
